var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.95312 16.371H35.5469C35.924 16.371 36.2856 16.5256 36.5523 16.8009C36.8189 17.0761 36.9688 17.4494 36.9688 17.8387V45.7258C36.9688 46.8936 36.5193 48.0136 35.7194 48.8394C34.9194 49.6651 33.8344 50.129 32.7031 50.129H12.7969C11.6656 50.129 10.5806 49.6651 9.78062 48.8394C8.98066 48.0136 8.53125 46.8936 8.53125 45.7258V17.8387C8.53125 17.4494 8.68105 17.0761 8.94771 16.8009C9.21436 16.5256 9.57602 16.371 9.95312 16.371V16.371Z",
    fill: "#1A50DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 32.5161H28.4375",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 38.3871H28.4375",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95312 16.371H35.5469C35.924 16.371 36.2856 16.5256 36.5523 16.8009C36.8189 17.0761 36.9688 17.4494 36.9688 17.8387V45.7258C36.9688 46.8936 36.5193 48.0136 35.7194 48.8394C34.9194 49.6651 33.8344 50.129 32.7031 50.129H12.7969C11.6656 50.129 10.5806 49.6651 9.78062 48.8394C8.98066 48.0136 8.53125 46.8936 8.53125 45.7258V17.8387C8.53125 17.4494 8.68105 17.0761 8.94771 16.8009C9.21436 16.5256 9.57602 16.371 9.95312 16.371V16.371Z",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 13.4355V19.3065",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.4355V19.3065",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2812 13.4355V19.3065",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.8333 15.8064L40.6875 8.4301L44.0435 4.96586C44.1385 4.86629 44.2517 4.78722 44.3766 4.73325C44.5014 4.67928 44.6355 4.65149 44.7708 4.65149C44.9062 4.65149 45.0402 4.67928 45.1651 4.73325C45.29 4.78722 45.4032 4.86629 45.4982 4.96586L51.1893 10.8406C51.2858 10.9386 51.3624 11.0555 51.4147 11.1844C51.4669 11.3133 51.4939 11.4517 51.4939 11.5914C51.4939 11.7311 51.4669 11.8695 51.4147 11.9984C51.3624 12.1273 51.2858 12.2441 51.1893 12.3422L47.8333 15.8064Z",
    fill: "#1A50DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1622 28.4516H29.4583C29.1876 28.4516 28.9279 28.3406 28.7365 28.143C28.5451 27.9453 28.4375 27.6773 28.4375 27.3978V21.5099C28.437 21.3731 28.4627 21.2375 28.5131 21.111C28.5634 20.9844 28.6375 20.8693 28.731 20.7723L44.0435 4.96586C44.1385 4.86629 44.2517 4.78722 44.3766 4.73325C44.5014 4.67928 44.6355 4.65149 44.7708 4.65149C44.9062 4.65149 45.0402 4.67928 45.1651 4.73325C45.29 4.78722 45.4032 4.86629 45.4982 4.96586L51.1893 10.8406C51.2858 10.9386 51.3624 11.0555 51.4147 11.1844C51.4669 11.3133 51.4939 11.4517 51.4939 11.5914C51.4939 11.7311 51.4669 11.8695 51.4147 11.9984C51.3624 12.1273 51.2858 12.2441 51.1893 12.3422L35.8768 28.1487C35.7829 28.2452 35.6714 28.3216 35.5488 28.3736C35.4261 28.4256 35.2948 28.4521 35.1622 28.4516Z",
    fill: "#DEE9E8",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6875 8.43011L47.8333 15.8065",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2603 12.1183L32.0103 24.7634",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5194 28.3857L28.5012 21.1411",
    stroke: "#1A50DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/noTasks.8258908ac3a948d9ec144e7f089dada8.svg";
export { ForwardRef as ReactComponent };